<div class="bulletin-board">
  <div class="title-container">
    <span class="title">Bulletin Board</span>
  </div>
  <div class="content">
    <div class="top-section">
      <app-new-button
        leftIcon="arrow_back"
        size="sm"
        (clickHandler)="goBack()"
        color="bare"x
      >Back</app-new-button>
      <span class="top-section-title">{{ isNewPost ? 'New Post' : 'Edit Post' }}</span>
    </div>
    <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>
    <div *ngIf="!isLoading" class="bottom-section">
      <div class="subtitle-container">
        <span class="subtitle">Title & Content</span>
      </div>
      <div class="post-content-container">
        <div class="post-title-field-container">
          <span class="post-title-field-label">Post Title (required)</span>
          <input
            #titleInput="ngModel"
            [(ngModel)]="post.title"
            class="post-title-field-value"
            [autofocus]="true"
            [ngClass]="{'error-state':  post.title.trim() === '' && titleInput.touched }"
            />
            <p class="klabel-medium error" *ngIf="post.title.trim() === '' && titleInput.touched">Title is required</p>
          </div>
          <app-rich-text-editor
            #contentEditor="ngModel"
            class="content-editor"
            fieldName="Content"
            required
            [(ngModel)]="post.content"
          ></app-rich-text-editor>
      </div>
    </div>
    <div *ngIf="!isLoading" class="buttons-container">
      <app-new-button
        *ngIf="!isNewPost && post.id"
        size="sm"
        (clickHandler)="deletePost()"
        color="red"
      >Delete Post</app-new-button>

      <div class="right-side-buttons">
        <app-new-button
          size="sm"
          (clickHandler)="goBack()"
          color="bare"
        >Cancel & Exit</app-new-button>
        <app-new-button
          size="sm"
          (clickHandler)="isNewPost ? createPost() : updatePost()"
          color="green"
          >{{ isNewPost ? 'Create Post' : 'Update Post' }}</app-new-button>
      </div>
    </div>
  </div>
</div>
